import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class AssessmentPeriodForm extends Vue {
  $refs!: {
    formRef: HTMLFormElement;
  };

  private name = '';
  private description = '';
  private startDate = '';
  private endDate = '';
  private ruleOptions = {
    name: [(v: string) => !!v || 'Assessment period name is required'],
    startDate: [
      (v: string) => !!v || 'Start date is required',
      (v: string) => (v && this.validateDateFields()) || 'Start date must be before end date'
    ],
    endDate: [
      (v: string) => !!v || 'End date is required',
      (v: string) => (v && this.validateDateFields()) || 'End date must be after start date'
    ]
  };

  validateDateFields(): boolean {
    return !this.startDate || !this.endDate || moment(this.startDate).isBefore(moment(this.endDate));
  }

  formValidate(): boolean {
    return this.$refs.formRef.validate();
  }

  save(): void {
    if (this.formValidate()) {
      this.$emit('createNew', this.name, this.description, this.startDate, this.endDate);
    }
  }

  cancel(): void {
    this.$emit('closeDialog');
    this.name = '';
    this.startDate = '';
    this.endDate = '';
  }
}
